import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { VerificationServiceChangeRequest } from "@idw-types/data/verification-service";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";

type DeployNowVerificationServiceChangeRequestModalProps = {
    serviceName: string;
    apiKey: string;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<VerificationServiceChangeRequest>;
};

export const DeployNowVerificationServiceChangeRequestModal = (props: DeployNowVerificationServiceChangeRequestModalProps) => {
    const { serviceName, apiKey, onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>This action will <b>immediately deploy</b> the Change Request for the Verification Service
                    named <b>{serviceName}</b> with API Key <b>{apiKey}</b>.</p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.SUBMIT}
            title={"Deploy Verification Service Change Request"}
            body={bodyElement}
            buttonText={"Deploy Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};